import _get from 'lodash/get';
import {
  DocumentationSortInputObject,
  SortDirectionEnum,
} from 'graphql-common';
import { GetUrlParams, OrderingParams } from '@lib/enums/urls';

// Table ordering state carries the column id, which matches the sort key the
// query expects (see getIndexingDocumentsTableColumns). Neither indexing axis
// is sortable server-side — these sets are small by nature — so only the name
// column is marked sortable and nothing else can reach this.
export default function getIndexingDocumentsSorts(
  orderingParams: OrderingParams,
): DocumentationSortInputObject | undefined {
  const field = _get(orderingParams, GetUrlParams.OrderingField);
  const direction = _get(orderingParams, GetUrlParams.OrderingDirection);
  if (!field || !direction) return undefined;
  return {
    [field]: direction as SortDirectionEnum,
  } as DocumentationSortInputObject;
}
